"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import type { Tab } from "./questions";
const fadeDown = {
  initial: {
    opacity: 0,
    y: -16
  },
  animate: {
    opacity: 1,
    y: 0
  }
};
function transition(delay: number) {
  return {
    duration: 0.6,
    ease: [0.16, 1, 0.3, 1] as const,
    delay
  };
}
interface FaqHeroProps {
  tab: Tab;
  onTabChange: (tab: Tab) => void;
}
export function FaqHero(t0) {
  const $ = _c(13);
  const {
    tab,
    onTabChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute inset-0 pointer-events-none"><div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-primary-300 opacity-30" /><div className="absolute -bottom-16 -left-16 w-72 h-72 rounded-full bg-primary-500 opacity-20" /><div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-150 h-150 rounded-full border border-primary-200 opacity-20" /><div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-95 h-95 rounded-full border border-primary-200 opacity-15" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = transition(0.1);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <motion.div {...fadeDown} transition={t2} className="inline-flex items-center gap-2 bg-primary-300/40 border border-primary-200/60 rounded-full px-4 py-1.5 backdrop-blur-sm"><span className="text-white text-xs font-semibold uppercase tracking-widest">Ajuda</span></motion.div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <motion.h1 {...fadeDown} transition={transition(0.25)} className="text-4xl md:text-6xl font-bold text-white leading-tight">Perguntas Frequentes</motion.h1>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <motion.p {...fadeDown} transition={transition(0.4)} className="text-primary-50 text-lg md:text-xl max-w-2xl leading-relaxed">Tire suas dúvidas sobre o Clique Médicos e como funciona o serviço.</motion.p>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = transition(0.5);
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = ["all", "voucher"];
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== onTabChange || $[8] !== tab) {
    t8 = <div className="relative w-full max-w-8xl mx-auto px-6 sm:px-8 md:px-16 py-20 md:py-28 flex flex-col items-center gap-5 text-center">{t3}{t4}{t5}<motion.div {...fadeDown} transition={t6} className="flex gap-3 mt-2">{(t7 as Tab[]).map(t => <button key={t} type="button" onClick={() => onTabChange(t)} className={`text-sm md:text-base rounded-full font-semibold px-5 py-2 transition-all duration-200 cursor-pointer ${tab === t ? "bg-white text-primary-600 shadow-sm" : "text-white bg-primary-300/30 hover:bg-primary-300/50 border border-primary-200/40"}`}>{t === "all" ? "Geral" : "Vale-compra"}</button>)}</motion.div></div>;
    $[7] = onTabChange;
    $[8] = tab;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="absolute bottom-0 left-0 right-0 h-12 bg-primary-50" style={{
      clipPath: "ellipse(55% 100% at 50% 100%)"
    }} />;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t8) {
    t10 = <section className="relative bg-primary-400/80 overflow-hidden">{t1}{t8}{t9}</section>;
    $[11] = t8;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  return t10;
}